'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["resolverOptions"];
import { createGetAutomatedEmailsByIds, createGetAutomatedEmailsSearchPage, getAutomatedEmailsByIds, getAutomatedEmailsSearchPage } from 'reference-resolvers/api/AutomatedEmailsAPI';
import { AUTOMATED_EMAILS } from 'reference-resolvers/constants/CacheKeys';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
export const createAutomatedEmailReferenceResolver = (sourceApp, options) => createBatchedReferenceResolver(Object.assign({
  cacheKey: AUTOMATED_EMAILS,
  createFetchByIds: opts => createGetAutomatedEmailsByIds(Object.assign({}, opts))(sourceApp),
  createFetchSearchPage: createGetAutomatedEmailsSearchPage,
  fetchByIds: getAutomatedEmailsByIds(sourceApp),
  fetchSearchPage: getAutomatedEmailsSearchPage
}, options));
export default ((sourceApp, options) => {
  const opts = _objectWithoutPropertiesLoose(options, _excluded);
  return createAutomatedEmailReferenceResolver(sourceApp, opts);
});